import api from "./api";

export const getInvoiceDetails = async (number, customerId) => {
  return await api.get(`/api/invoices/${number}`, {
    params: { customerId },
    bypassInterceptor: true
  });
};
